import * as React from 'react';
import type { SVGProps } from 'react';
const SvgModerator = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="M23 12a3.99 3.99 0 0 0-2.295-3.604 3.99 3.99 0 0 0-.926-4.173 3.99 3.99 0 0 0-4.173-.926A3.99 3.99 0 0 0 12.001 1a3.99 3.99 0 0 0-3.606 2.296 3.99 3.99 0 0 0-4.173.926 3.99 3.99 0 0 0-.926 4.173A3.99 3.99 0 0 0 1 12c0 1.596.942 2.964 2.296 3.606a3.99 3.99 0 0 0 .926 4.172 3.99 3.99 0 0 0 4.173.927A3.99 3.99 0 0 0 12 23a3.99 3.99 0 0 0 3.605-2.295 3.99 3.99 0 0 0 4.173-.927 3.99 3.99 0 0 0 .926-4.172A3.99 3.99 0 0 0 23 12m-11.71 5.698L7.308 15.04l1.387-2.08 2.016 1.344L16 7.25l2 1.5-6.71 8.947Z"
        />
    </svg>
);
export default SvgModerator;
